/* Theme-only behavior: no reference-site API calls, accounts, tracking or checkout. */
(() => {
  // Decorative hourly value, shared by all tabs. This is not visitor analytics.
  const updateOnline = () => {
    const hour = Math.floor(Date.now() / 3600000);
    const value = 100 + (hour * 73 + hour * hour * 11) % 101;
    document.querySelectorAll('[data-online-value]').forEach(el => { el.textContent = String(value); });
  };
  setInterval(updateOnline, 30000);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) updateOnline(); });
  document.addEventListener('keydown', event => {
    if (window.Shopify?.designMode || event.target.closest?.('input, textarea, [contenteditable="true"]')) return;
    if ((event.ctrlKey || event.metaKey) && !event.altKey && !event.shiftKey && event.key.toLowerCase() === 's') event.preventDefault();
  });

  const initCounters = root => {
    root.querySelectorAll('[data-count-up]').forEach(el => {
      if (el.dataset.countReady) return;
      el.dataset.countReady = 'true';
      const original = el.textContent.trim();
      // Only a single number: leave ratings (4.8/5), schedules (24/7), and text alone.
      const match = original.match(/^([^\d]*)(\d{1,3}(?:[,\s]\d{3})+|\d+)(\.\d+)?([^\d]*)$/);
      if (!match || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const target = Number((match[2] + (match[3] || '')).replace(/[,\s]/g, ''));
      if (!Number.isSafeInteger(Math.trunc(target)) || target <= 0) return;
      const separator = match[2].match(/[,\s]/)?.[0];
      const decimals = (match[3] || '').slice(1).length;
      const format = value => {
        let [whole, fraction] = value.toFixed(decimals).split('.');
        if (separator) whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
        return match[1] + whole + (fraction ? '.' + fraction : '') + match[4];
      };
      const measure = document.createElement('span');
      measure.className = 'divine-count-measure'; measure.textContent = original; measure.setAttribute('aria-hidden', 'true');
      const visual = document.createElement('span');
      visual.className = 'divine-count-value'; visual.textContent = format(0); visual.setAttribute('aria-hidden', 'true');
      const accessible = document.createElement('span');
      accessible.className = 'visually-hidden'; accessible.textContent = original;
      el.replaceChildren(measure, visual, accessible);
      el.classList.add('divine-count');
      const start = () => {
        const begin = performance.now();
        const frame = now => {
          if (!el.isConnected) return;
          const progress = Math.min((now - begin) / 1500, 1);
          visual.textContent = progress === 1 ? original : format(target * (1 - Math.pow(1 - progress, 3)));
          if (progress < 1) requestAnimationFrame(frame);
        };
        requestAnimationFrame(frame);
      };
      if (!('IntersectionObserver' in window)) { start(); return; }
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); start(); }
      });
      observer.observe(el);
      const unload = event => { if (event.target.contains(el)) { observer.disconnect(); document.removeEventListener('shopify:section:unload', unload); } };
      document.addEventListener('shopify:section:unload', unload);
    });
  };
  const init = (root = document) => {
    updateOnline();
    initCounters(root);
    root.querySelectorAll('[data-support-open]').forEach(button=>{if(button.dataset.ready)return;button.dataset.ready='true';button.addEventListener('click',()=>document.getElementById(button.dataset.supportOpen)?.showModal());});
    root.querySelectorAll('[data-support-close]').forEach(button=>{if(button.dataset.ready)return;button.dataset.ready='true';button.addEventListener('click',()=>button.closest('dialog').close());});
    root.querySelectorAll('video.cv10__stageVid').forEach(video => {
      if (video.dataset.ready) return;
      video.dataset.ready = 'true';
      video.controls = false; video.muted = true; video.defaultMuted = true;
      video.autoplay = true; video.loop = true; video.playsInline = true;
      video.disablePictureInPicture = true; video.disableRemotePlayback = true;
      video.tabIndex = -1;
      video.addEventListener('contextmenu', event => event.preventDefault());
      const play = () => { if (!document.hidden) video.play()?.catch(() => {}); };
      video.addEventListener('canplay', play, { once: true });
      document.addEventListener('visibilitychange', play);
      play();
    });
    root.querySelectorAll('[data-marquee]').forEach(viewport => {
      if (viewport.dataset.ready) return;
      viewport.dataset.ready = 'true';
      const track = viewport.querySelector('.cosmo-marquee-track');
      const group = track.firstElementChild;
      if (!group.children.length) return;
      const originals = [...group.children];
      const clone = element => {
        const copy = element.cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        copy.removeAttribute('id'); copy.removeAttribute('data-editor-block'); copy.removeAttribute('data-shopify-editor-block');
        copy.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));
        copy.querySelectorAll('a,button,input').forEach(el=>el.tabIndex=-1);
        if (copy.matches('a')) copy.tabIndex=-1;
        return copy;
      };
      const build = () => {
        [...track.children].slice(1).forEach(el=>el.remove());
        [...group.children].slice(originals.length).forEach(el=>el.remove());
        let count=0;
        while(group.getBoundingClientRect().width < viewport.clientWidth && count++<12) originals.forEach(el=>group.append(clone(el)));
        track.append(clone(group));
        const gap=parseFloat(getComputedStyle(track).gap)||0;
        viewport.style.setProperty('--marquee-distance',`${group.getBoundingClientRect().width+gap}px`);
        viewport.dataset.running='true';
      };
      build();
      const observer=new ResizeObserver(build);observer.observe(viewport);
      document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(viewport))observer.disconnect();},{once:true});
    });
    root.querySelectorAll('.cv10__faqList, .cDisc_faq').forEach(list => {
      if(list.dataset.ready)return;list.dataset.ready='true';
      const items=[...list.querySelectorAll('details')];
      const animations=new WeakMap();
      const animate=(item,open)=>{
        animations.get(item)?.cancel();
        const from=item.getBoundingClientRect().height;
        const summary=item.querySelector('summary');
        item.open=true;
        const to=open?item.scrollHeight:summary.getBoundingClientRect().height+2;
        if(matchMedia('(prefers-reduced-motion: reduce)').matches){item.open=open;return;}
        item.style.overflow='hidden';
        const animation=item.animate([{height:`${from}px`},{height:`${to}px`}],{duration:320,easing:'cubic-bezier(.22,1,.36,1)'});
        animations.set(item,animation);item.dataset.expanding=String(open);
        animation.onfinish=()=>{item.open=open;item.style.overflow='';delete item.dataset.expanding;animations.delete(item);};
      };
      items.forEach(item=>item.querySelector('summary').addEventListener('click',event=>{
        event.preventDefault();
        const open=item.dataset.expanding!==undefined?item.dataset.expanding!=='true':!item.open;
        if(open)items.filter(other=>other!==item&&(other.open||other.dataset.expanding==='true')).forEach(other=>animate(other,false));
        animate(item,open);
      }));
    });
    root.querySelectorAll('[data-cosmo-filter]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const input = section.querySelector('[data-filter-query]');
      input?.addEventListener('input', () => {
        let visible = 0;
        const query = input.value.trim().toLocaleLowerCase();
        section.querySelectorAll('[data-filter-item]').forEach(card => {
          card.hidden = !card.dataset.name.toLocaleLowerCase().includes(query);
          if (!card.hidden) visible++;
        });
        section.querySelector('[data-filter-empty]').hidden = visible !== 0;
      });
    });
    root.querySelectorAll('[data-cosmo-status]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      let letter = '';
      const query = section.querySelector('[data-status-query]');
      const game = section.querySelector('[data-status-game]');
      const state = section.querySelector('[data-status-state]');
      const filter = () => {
        let visible = 0;
        section.querySelectorAll('[data-status-item]').forEach(card => {
          const name = card.dataset.name.toLocaleLowerCase();
          const matchesLetter = !letter || (letter === 'popular' ? card.dataset.popular === 'true' : (card.dataset.game || card.dataset.name).toLocaleUpperCase().startsWith(letter));
          card.hidden = !(matchesLetter && (name + ' ' + card.dataset.game.toLocaleLowerCase()).includes(query.value.trim().toLocaleLowerCase()) && (!game.value || game.value === card.dataset.game) && (!state.value || state.value === card.dataset.state));
          if (!card.hidden) visible++;
        });
        section.querySelector('[data-status-empty]').hidden = visible !== 0;
      };
      query.addEventListener('input', filter);
      game.addEventListener('change', filter);
      state.addEventListener('change', filter);
      section.querySelectorAll('[data-letter]').forEach(button => button.addEventListener('click', () => {
        letter = button.dataset.letter;
        section.querySelectorAll('[data-letter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        filter();
      }));
    });
    root.querySelectorAll('[data-cosmo-menu]').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      const activateOnKey = (el) => el.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); el.click(); }
      });
      const tabs = [...menu.querySelectorAll('[data-tab]')];
      menu.querySelector('.cv10__menuTabs').setAttribute('role', 'tablist');
      const scope = menu.closest('[id^="shopify-section-"]')?.id || 'cosmo-showcase';
      tabs.forEach((tab,index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('tabindex', tab.classList.contains('is-on') ? '0' : '-1');
        tab.setAttribute('aria-selected', String(tab.classList.contains('is-on')));
        tab.id = `${scope}-tab-${index}`;
        const panel = menu.querySelector(`[data-panel="${tab.dataset.tab}"]`);
        panel.id = `${scope}-panel-${index}`;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        tab.setAttribute('aria-controls', panel.id);
        tab.addEventListener('click', () => {
          tabs.forEach(t => { const selected = t === tab; t.classList.toggle('is-on', selected); t.setAttribute('aria-selected', String(selected)); t.tabIndex = selected ? 0 : -1; });
          menu.querySelectorAll('[data-panel]').forEach(p => p.classList.toggle('is-on', p === panel));
        });
        activateOnKey(tab);
        tab.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          tabs[next].click(); tabs[next].focus();
        });
      });
      menu.querySelectorAll('[data-fx]').forEach(toggle => {
        toggle.setAttribute('role', 'switch'); toggle.tabIndex = 0;
        toggle.setAttribute('aria-checked', String(toggle.classList.contains('is-on')));
        toggle.addEventListener('click', () => {
          const on = toggle.classList.toggle('is-on');
          toggle.setAttribute('aria-checked', String(on));
          menu.querySelector('.cv10__pv')?.classList.toggle(`fx-${toggle.dataset.fx}`, on);
        });
        activateOnKey(toggle);
      });
      menu.querySelectorAll('[data-slide]').forEach(row => {
        const input = document.createElement('input'); input.type = 'range'; input.className = 'cosmo-demo-range';
        const isFov = row.dataset.slide === 'fov'; input.min = isFov ? '30' : '1'; input.max = isFov ? '180' : '10'; input.step = isFov ? '1' : '.1'; input.value = isFov ? '114' : '3.4';
        input.setAttribute('aria-label', row.firstElementChild.textContent);
        row.querySelector('.cv10__track').replaceWith(input);
        input.addEventListener('input', () => {
          row.querySelector('.cv10__mVal').textContent = input.value + (isFov ? '°' : '');
          if (isFov) menu.querySelector('.cv10__pv').style.setProperty('--fov', `${Number(input.value) * 1.6}px`);
        });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const details = event.target.closest('details'); if (details) details.open = true;
    if (event.target.matches('.cv10__rev')) event.target.scrollIntoView({block:'nearest', inline:'center'});
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.cosmo-mobile-nav[open],.cosmo-nav-dropdown[open]').forEach(details => { details.open = false; details.querySelector('summary').focus(); });
  });
})();
